import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

export type BrandedBenefitInfoProps = {
    /** First line of the header, e.g. "Enjoy benefits of" */
    headerPrefix: string
    /** Branded name shown in purple, e.g. "Value Max" */
    brandedName: string
    /** Body description text */
    description: string
    /** Optional class name for the root container */
    className?: string
}

const BrandedBenefitInfo: React.FC<BrandedBenefitInfoProps> = ({
    headerPrefix,
    brandedName,
    description,
    className = ''
}) => {
    return (
        <Container
            className={`br-12 px-3 py-2 mb-8 bg-blue-100 ${className}`.trim()}
            css={{
                width: '164px',
            }}
        >
            <Container className="flex flex-wrap flex-middle mb-1">
                <Typography className="mr-1" color="primary" variant="HM3">
                    {headerPrefix}
                </Typography>
                <Typography colorCode='#5F1AB6' variant="HM3">
                    {brandedName}
                </Typography>
            </Container>
            <Typography variant="P3">
                {description.replace('{fare}', brandedName)}
            </Typography>
        </Container>
    )
}

export default BrandedBenefitInfo
